import AssociateUsersPermissions from "../../features/dashboard/permissions/AssociateUsersPermissions"

function AssociateUsersPermissionsDB() {
    return <AssociateUsersPermissions />
}

export default AssociateUsersPermissionsDB